export default class {
    onCreate() {
        this.state = {
            open: false,
            dialogData: false
        };
    }
    openDialog(data) {
        this.state.open = true;
        this.state.dialogData = data;
    }
    closeDialog() {
        this.state.open = false;
        this.state.dialogData = false;
    }
}
